var exports = {
  "jD": "xe533113f--a90d14--cont",
  "ne": "xe533113f--a90d14--controls",
};

module.exports = exports;
